module.exports = __webpack_public_path__ + "static/media/backing.83f70d87.png";